// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-About-___about__container___3Vn8x","page-content":"src-components-About-___about__page-content___2QSXm","para-text":"src-components-About-___about__para-text___5eNp4","text-content":"src-components-About-___about__text-content___Rqull"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/about.css
// module id = 818
// module chunks = 0